import React, {Fragment} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./table.module.scss";

function SizeRows({rows}) {
  return rows.map((row, i) => (
    <tr
      key={i}
      className={classNames(styles.row, i === 0 && styles.headRow)}
    >
      {row.map((cell, j) => (
        <td
          key={`${cell}${j}`}
          className={classNames(styles.cell, j === 0 && styles.headCell)}
        >
          {cell}
        </td>
      ))}
    </tr>
  ));
}

function ItemsRows({items}) {
  return items.map(({name, table}) => (
    <Fragment key={name}>
      <tr className={styles.dividerRow}><td>{name}:</td></tr>
      <SizeRows rows={table}/>
    </Fragment>
  ));
}

function Table({items}) {
  return (
    <table className={styles.root}>
      <tbody>
        {Array.isArray(items[0]) ? <SizeRows rows={items}/> : <ItemsRows items={items}/>}
      </tbody>
    </table>
  );
}

Table.propTypes = {
  items: PropTypes.array
};

export default Table;
